import '@emotion/react';
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var ltrSupport = process.env.NODE_ENV === "production" ? {
  name: "44ic4r",
  styles: "[dir='ltr'],:root{--ltr-space:1px;--ltr-multiplier:1;--rtl-space:0px;--rtl-multiplier:0;}[dir='rtl']{--ltr-space:0px;--ltr-multiplier:0;--rtl-space:1px;--rtl-multiplier:1;}"
} : {
  name: "1wgsaj1-ltrSupport",
  styles: "[dir='ltr'],:root{--ltr-space:1px;--ltr-multiplier:1;--rtl-space:0px;--rtl-multiplier:0;}[dir='rtl']{--ltr-space:0px;--ltr-multiplier:0;--rtl-space:1px;--rtl-multiplier:1;};label:ltrSupport;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export { ltrSupport };
